import Select from './Select'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { SelectProps } from './types'

const ClientSelect = forwardRef<HTMLSelectElement, SelectProps>(function ClientSelect(
  { onChange: onChange_, onClick: onClick_, ...props },
  ref
) {
  const { disabled } = props
  const onChange = disabled ? preventDefault : onChange_
  const onClick = disabled ? preventDefault : onClick_
  return <Select {...props} onChange={onChange} onClick={onClick} ref={ref} />
})

export default ClientSelect
